<script>
    import LineChartStatesOnly from "./LineChartStatesOnly.svelte";
    import BarChart from "./BarChart.svelte";

    export let weeklyData = [];
    export let highlightStates;
    export let guff;
    export let stateMapping;

    let show = 'national';


</script>
<div class="max-width-md" style="max-width: 1000px; margin: 5em auto;">
    <h2>{ guff["over_time_hed"] }</h2>
        
    <div class="controls">
        <div class="chart-context">{ guff["over_time_dek"] }</div>
        <div class="toggle">
            <button
            class:active={show === 'national'}
            on:click={() => (show = 'national')}
            >
            {guff["national"]}
            </button>
            <button
            class:active={show === 'all-states'}
            on:click={() => (show = 'all-states')}
            >
            {guff["state"]}
            </button>
        </div>
    </div>
    
    <div id="chart-wrapper-national">
        <div class:hidden={show != 'national'} >
        <BarChart data={weeklyData} wrapperClass="#chart-wrapper-national" week_of={guff["week_of"]} cases={guff["cases"]}/>
        </div>
        <div class:hidden={show !== 'all-states'}>
            <LineChartStatesOnly  week_of={guff["week_of"]} total_cases={guff["total_cases"]} data={weeklyData} {highlightStates} wrapperClass="#chart-wrapper-national" {stateMapping}/>
        </div>
        
    </div>
    <div>
        {#if show === 'national'}
        <div class="chart-note">
            Note: {guff["bar_chart_note"]}
            </div>
        {:else}
        <div class="chart-note">
            Note: {guff["line_chart_note"]}
            </div>
        {/if}
    </div>
    
</div>
